module.exports = __webpack_public_path__ + "static/media/LYD-USDT.e4b82407.png";